import { useFocusTrap } from '@vueuse/integrations/useFocusTrap';

interface Props {
  immediate?: boolean;
}

const defaultProps: Props = {
  immediate: true,
};

export const useModalFocusTrap = (props?: Props) => {
  const focusTarget = ref();
  const { deactivate: deactivateFocusTrap, activate: activateFocusTrap } =
    useFocusTrap(focusTarget, {
      immediate: props?.immediate ?? defaultProps.immediate,
      escapeDeactivates: false,
      clickOutsideDeactivates: false,
      allowOutsideClick: true,
    });

  return {
    focusTarget,
    deactivateFocusTrap,
    activateFocusTrap,
  };
};
